/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled      from 'styled-components';
import { Colours } from '../../../styles/variables';
import { Media }   from '../../../styles/utilities';


/*********************************************************************************
 2. Heading Components
 *********************************************************************************/

const baseHeading = styled.h1`
  line-height: 1.5;
  font-weight: 700;
  margin: 0;
  display: block;
  font-family: inherit;
  ${Media.Tablet`
    line-height: 1;
  `}
`;

export const Heading1 = baseHeading.extend`
  font-size: 28px;
`;

export const Heading2 = baseHeading.withComponent('h2').extend`
  font-size: 20px;
`;

export const Heading3 = baseHeading.withComponent('h3').extend`
  font-size: 16px;
  color: ${Colours.Alto};
`;

export const LargeResponsiveHeading = baseHeading.extend`
  font-size: 30px;
  ${Media.Tablet`
    line-height: 1.5;
    font-size: 48px;
  `}
`;

/*********************************************************************************
 3. Text Components
 *********************************************************************************/

const baseText = styled.p`
  line-height: 1.5;
  margin: 0;
  font-family: inherit;
`;

export const TinyText = baseText.extend`
  font-size: 10px;
`;

export const SmallText = baseText.extend`
  font-size: 12px;
`;

export const RegularText = baseText.extend`
  font-size: 16px;
`;

export const LargeText = baseText.extend`
  font-size: 20px;
`;

export const BigText = baseText.extend`
  font-size: 48px;
`;

export const MassiveText = baseText.extend`
  font-size: 64px;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTypography/index.js